import React from 'react';
import Nav2 from '../Nav2/Nav2';
import './flowdonasi.css'
import CardItem from '../Cards/CardItem'
import Uang from '../Cards/CardsImages/uang.png'
import Makanan from '../Cards/CardsImages/makanan.png';
import Medis from '../Cards/CardsImages/medis.png';
import Pakaian from '../Cards/CardsImages/pakaian.png';
import MainanAnak from '../Cards/CardsImages/mainan.png';
import Buku from '../Cards/CardsImages/buku.png';
import Elektronik from '../Cards/CardsImages/elektronik.png'

export default function FlowDonasi() {
    return (
        <div>
            <Nav2 />
            <div className="mapping-donasi-card">

            </div>
            <h5 className="flow-donasi-title">Pilih Jenis Donasi</h5>
            <div className='cards1'>
                <div className='cards__container'>
                    <div className='cards__wrapper' >
                        <ul className='cards__items'>
                        </ul>
                        <ul className='cards__items'>
                            <CardItem
                                src={Makanan}
                                text='Ayo Donasi Sekarang!'
                                label='Makanan'
                                path='/donasi-makanan'
                            />
                            <CardItem
                                src={Pakaian}
                                text='Ayo Donasi Sekarang!'
                                label='Pakaian'
                                path='/donasi-pakaian'
                            />
                            <CardItem
                                src={Medis}
                                text='Ayo Donasi Sekarang!'
                                label='Medis'
                                path='/donasi-medis'
                            />
                            <CardItem
                                src={MainanAnak}
                                text='Ayo Donasi Sekarang!'
                                label='Mainan Anak'
                                path='/donasi-mainan'
                            />
                        </ul>
                    </div>
                </div>
                <div className='cards__container'>
                    <div className='cards__wrapper' >
                        <ul className='cards__items'>
                        </ul>
                        <ul className='cards__items'>
                            <CardItem
                                src={Buku}
                                text='Ayo Donasi Sekarang!'
                                label='Buku'
                                path='/donasi-buku'
                            />
                            <CardItem
                                src={Elektronik}
                                text='Ayo Donasi Sekarang!'
                                label='Elektronik'
                                path='/donasi-elektronik'
                            />
                            <CardItem
                                src={Uang}
                                text='Ayo Donasi Sekarang!'
                                label='Uang'
                                path='/donasi-uang'
                            />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}